import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { useBooking } from "../../lib/booking";

const NAV = [
  { id: "atelier", label: "Story" },
  { id: "services", label: "Services" },
  { id: "gallery", label: "Gallery" },
  { id: "team", label: "The Team" },
  { id: "visit", label: "Visit" },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const { openBooking } = useBooking();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 16);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const onBookClick = () => {
    setOpen(false);
    openBooking();
  };

  return (
    <header
      className="fs-header"
      data-testid="site-header"
      style={{ borderBottomColor: scrolled ? "var(--fs-line-strong)" : "var(--fs-line)" }}
    >
      <div className="fs-container flex items-center justify-between" style={{ height: "76px" }}>
        <a href="#top" className="flex items-center gap-2" data-testid="site-branding">
          <span style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: "1.55rem", fontWeight: 300, letterSpacing: "-0.01em", color: "var(--fs-ink)" }}>
            Friends Salon&nbsp;<span className="fs-ital">24</span>
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-9" data-testid="header-nav">
          {NAV.map((n) => (
            <a
              key={n.id}
              href={`#${n.id}`}
              className="fs-overline"
              style={{ color: "var(--fs-ink-soft)", fontWeight: 500, transition: "color 250ms ease" }}
              onMouseEnter={(e) => (e.currentTarget.style.color = "var(--fs-caramel)")}
              onMouseLeave={(e) => (e.currentTarget.style.color = "var(--fs-ink-soft)")}
              data-testid={`nav-${n.id}`}
            >
              {n.label}
            </a>
          ))}
          <button
            type="button"
            onClick={onBookClick}
            className="fs-btn-primary"
            style={{ padding: "0.85rem 1.6rem", fontSize: "0.66rem" }}
            data-testid="nav-book"
          >
            Reserve a Chair
          </button>
        </nav>

        <button
          className="md:hidden"
          aria-label="Open menu"
          onClick={() => setOpen((o) => !o)}
          data-testid="mobile-menu-toggle"
          style={{ color: "var(--fs-ink)", background: "transparent", border: "none", padding: "0.5rem" }}
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div
          className="md:hidden"
          data-testid="mobile-menu"
          style={{
            background: "rgba(248,242,231,0.97)",
            borderTop: "1px solid var(--fs-line)",
            padding: "1.5rem 1.5rem 2rem",
          }}
        >
          <nav className="flex flex-col gap-5">
            {NAV.map((n) => (
              <a
                key={n.id}
                href={`#${n.id}`}
                onClick={() => setOpen(false)}
                className="fs-overline"
                style={{ color: "var(--fs-ink)", fontSize: "0.78rem" }}
                data-testid={`mobile-nav-${n.id}`}
              >
                {n.label}
              </a>
            ))}
            <button
              type="button"
              onClick={onBookClick}
              className="fs-btn-primary"
              style={{ marginTop: "0.5rem", justifyContent: "center" }}
              data-testid="mobile-nav-book"
            >
              Reserve a Chair
            </button>
          </nav>
        </div>
      )}
    </header>
  );
}
